import { storyblokEditable } from "@storyblok/react"
import { Button, Conditional } from "iq-blueberry"

import { ctas } from "./styles"

const CTAs = ({ blok }) => {
  function handleClick(e) {
    e.preventDefault()
    const btnLink = e.currentTarget.dataset.link

    if (btnLink === "form") {
      const form = document.querySelector("#form-title")
      const positionTop =
        form.getBoundingClientRect().top + window.pageYOffset - 80
      window.scrollTo({
        top: positionTop,
        behavior: "auto",
      })

      const firstInput = document.querySelectorAll(
        'form input[class*="iq-input"]'
      )[0]
      firstInput?.focus()
    }

    if (btnLink === "faq") {
      const firstFaq = document.querySelector("#faq")
      const positionTop =
        firstFaq?.getBoundingClientRect().top + window.pageYOffset - 80
      window.scrollTo({
        top: positionTop,
        behavior: "auto",
      })
    }
  }

  return (
    <div css={ctas}>
      <Conditional
        condition={!!blok.length}
        renderIf={blok.map((btn) => (
          <Button
            {...storyblokEditable(btn)}
            key={btn._uid}
            type={btn?.button_type}
            expand="x"
            justify="center"
            data-click={btn?.button_type}
            data-link={btn?.button_link}
            data-custom="button-cta"
            onClick={handleClick}
          >
            {btn.button_text}
          </Button>
        ))}
        renderElse={
          <Button
            type="primary"
            expand="x"
            justify="center"
            data-click="primary"
            data-link="form"
            data-custom="button-cta"
            onClick={handleClick}
          >
            Peça Já
          </Button>
        }
      />
    </div>
  )
}

export default CTAs
